import '../user.scss'

import UserList from './UserList'
import withUserRoute from '../../../hoc/withUserRoute'
import useTranslations from '../../../hooks/useTranslations'
import ANTDButton from '../../../shared/antd/ANTDButton'
import { length } from '../../../utils/javascript'
import { getItem } from '../../../utils/localstorage'
import userManagement from '../container/userManagement.container'

const UserManagement = () => {
  const {
    adminId,
    userTitle,
    permission,
    showSendReminder,
    defaultPayload,
    currentUserView,
    handleAdd,
  } = userManagement()
  const { t } = useTranslations()
  const parentAdminId = getItem('adminId')

  return (
    <div>
      <div className="page-header-wrapper">
        <h2 className="page-title">{t(userTitle)}</h2>
        <div className="add-btn">
          {permission && (
            <ANTDButton type="primary" className="btn" onClick={handleAdd}>
              {t('btn_Add')}
            </ANTDButton>
          )}
        </div>
      </div>
      {length(currentUserView) ? (
        currentUserView?.map((item, index) => {
          const { payload, subTitle, needParent, needAdminId } = { ...item }

          return (
            <UserList
              key={`${userTitle}+${index}`}
              isSearch={true}
              {...{
                permission,
                payload: {
                  ...payload,
                  ...(needParent && { userId: adminId }),
                  ...(needAdminId && { userId: parentAdminId }),
                },
                showSendReminder,
                subTitle,
              }}
            />
          )
        })
      ) : (
        <UserList
          key={userTitle}
          isSearch={true}
          {...{
            permission,
            payload: defaultPayload,
            showSendReminder,
          }}
        />
      )}
    </div>
  )
}

export default withUserRoute(UserManagement)
